exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".refill-wrapper {\n  display: flex;\n  width: 341px;\n  align-items: center;\n  position: relative;\n  margin-top: 18px; }\n  .refill-wrapper .refill-field-wrapper {\n    display: flex;\n    align-items: center; }\n  .refill-wrapper .reason-field-wrapper {\n    margin-top: 16px; }\n  .refill-wrapper .currency-field-wrapper .text-field-float-label, .refill-wrapper .currency-field-wrapper .text-field-hint-text {\n    display: none; }\n  .refill-wrapper .currency-field-wrapper .text-field-error-text {\n    position: absolute;\n    right: 0;\n    z-index: -1; }\n  .refill-wrapper .currency-field-wrapper input {\n    padding-left: 14px;\n    text-align: center; }\n  .refill-wrapper .currency-field-wrapper .currency-sign {\n    top: 12px; }\n  .refill-wrapper .main-button {\n    align-self: flex-end; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/_molecules/RefillBalance/RefillBalance.scss
// module id = 1993
// module chunks = 0